import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';
import { Label } from './ui/label';
import { Input } from './ui/input';
import { toast } from 'sonner';
import { appointmentsAPI } from '../services/api';

const ArtEventSection = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    try {
      // Send to Formspree
      const formspreeResponse = await fetch('https://formspree.io/f/meegyjlr', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          type: 'Энергия: возвращение ресурса',
          _subject: `Новая запись на программу "Энергия: возвращение ресурса" - ${formData.name}`
        })
      });

      // Also save to database
      const appointmentData = {
        ...formData,
        type: 'energy-resource-program'
      };

      await appointmentsAPI.create(appointmentData);

      setIsSubmitting(false);

      if (formspreeResponse.ok) {
        toast.success('Запись подтверждена!', {
          description: `Подтверждение отправлено на ${formData.email}`
        });

        setFormData({ name: '', email: '', phone: '' });
        setIsDialogOpen(false);
      } else {
        toast.error('Ошибка отправки', {
          description: 'Попробуйте позже'
        });
      }
    } catch (error) {
      setIsSubmitting(false);
      toast.error('Ошибка отправки', {
        description: 'Попробуйте позже'
      });
    }
  };

  return (
    <section id="art-event" className="py-24 bg-soft-gray">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <span className="bg-rich-chocolate/10 text-rich-chocolate px-4 py-2 rounded-full text-sm font-medium">
                Групповая терапия
              </span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl text-charcoal mb-6">
              Энергия: возвращение ресурса
            </h2>
            <p className="text-lg text-warm-gray max-w-3xl mx-auto leading-relaxed">
              8 недель, после которых ты перестанешь жить в состоянии «я не вывожу»
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-cream-white p-8 rounded-2xl">
              <h3 className="font-serif text-2xl text-charcoal mb-6">ПРОГРАММА (8 ВСТРЕЧ)</h3>
              <div className="space-y-4 text-warm-gray">
                <p>1. «Надо» и внутренний критик<br />→ возвращаешь контроль над решениями</p>
                <p>2. Самооценка и обесценивание<br />→ появляется внутренняя опора</p>
                <p>3. Саботаж и внутренние стопы<br />→ начинаешь действовать легче</p>
                <p>4. Прокрастинация и перегруз<br />→ появляется фокус</p>
                <p>5. Сравнение и влияние других<br />→ меньше тревоги и сомнений</p>
                <p>6. Внутреннее напряжение<br />→ больше лёгкости</p>
                <p>7. Ограничения «мне нельзя»<br />→ расширяется свобода</p>
                <p>8. Внутренняя опора<br />→ устойчивое состояние</p>
              </div>
            </div>

            <div className="bg-cream-white p-8 rounded-2xl">
              <h3 className="font-serif text-2xl text-charcoal mb-6">ДОПОЛНИТЕЛЬНО</h3>
              <p className="text-warm-gray mb-3">Закрытый Telegram-канал:</p>
              <ul className="space-y-3 text-warm-gray mb-6">
                <li>• отслеживание энергии и состояния</li>
                <li>• поддержка между встречами</li>
                <li>• практики и задания</li>
                <li>• внедрение изменений в реальную жизнь</li>
              </ul>
              <p className="text-charcoal font-medium">Поэтому результат остаётся после программы.</p>
            </div>

            <div className="bg-cream-white p-8 rounded-2xl md:col-span-2">
              <h3 className="font-serif text-2xl text-charcoal mb-6">С ЧЕМ ВЫ УЙДЁТЕ</h3>
              <p className="text-warm-gray mb-3">После 8 недель у вас будет:</p>
              <ul className="space-y-3 text-warm-gray mb-6">
                <li>— понимание, куда уходит энергия</li>
                <li>— навык останавливать «сливы»</li>
                <li>— способность действовать без давления</li>
                <li>— больше энергии в течение дня</li>
                <li>— ясность и фокус</li>
                <li>— внутренняя опора</li>
                <li>— ощущение «я справляюсь»</li>
              </ul>
              <p className="text-charcoal font-medium">это не теория</p>
              <p className="text-charcoal font-medium">это новое состояние</p>
            </div>
          </div>

          <div className="bg-warm-sage p-8 md:p-12 rounded-3xl text-center mb-12">
            <h3 className="font-serif text-3xl text-cream-white mb-4">
              СТОИМОСТЬ
            </h3>
            <p className="text-cream-white/90 mb-8">
              <span className="text-2xl font-bold">200 €</span>
            </p>
            <p className="text-cream-white/90 mb-2">
              первые 4 места — <span className="text-2xl font-bold">160 €</span>
            </p>
            <p className="text-cream-white/90 mb-8">всего 8 мест</p>
            
            <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
              <DialogTrigger asChild>
                <button className="bg-cream-white text-warm-sage px-8 py-4 rounded-full font-medium hover:bg-cream-white/90 transition-colors">
                  Записаться
                </button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-md">
                <DialogHeader>
                  <DialogTitle className="font-serif text-2xl">Запись на программу</DialogTitle>
                </DialogHeader>
                <form onSubmit={handleSubmit} className="space-y-4 mt-4">
                  <div>
                    <Label htmlFor="art-name">Имя *</Label>
                    <Input
                      id="art-name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      required
                      placeholder="Ваше имя"
                    />
                  </div>
                  
                  <div>
                    <Label htmlFor="art-email">Email *</Label>
                    <Input
                      id="art-email"
                      type="email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      required
                      placeholder="your@email.com"
                    />
                  </div>

                  <div>
                    <Label htmlFor="art-phone">Телефон *</Label>
                    <Input
                      id="art-phone"
                      type="tel"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      required
                      placeholder="+31 6 12345678"
                    />
                  </div>

                  <button type="submit" className="btn-primary w-full" disabled={isSubmitting}>
                    {isSubmitting ? 'Отправка...' : 'Отправить заявку'}
                  </button>
                </form>
              </DialogContent>
            </Dialog>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArtEventSection;
